import { render, staticRenderFns } from "./EditEmployeeDetailsUser.vue?vue&type=template&id=da8b61b4"
import script from "./EditEmployeeDetailsUser.vue?vue&type=script&lang=js"
export * from "./EditEmployeeDetailsUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports